import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import './SingleSelect.scss'

class SingleSelect extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { title, value, isSelected, YPonClick, isView, isArray } = this.props
    return (
      <div className='SingleSelect' onClick={YPonClick}>
        {
          title &&
          <div className='title'>{title}</div>
        }
        <div className={classnames('select', {
          'select--selected': isSelected,
          'select--not-selected': !isSelected,
          'select--is-view': isView
        })}>
          {isArray && value.map(v => <p key={`${v}`}>{v}</p>)}
          {!isArray && <span>{value}</span>}
        </div>
      </div>
    )
  }
}

SingleSelect.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.array, PropTypes.string ]),
  isSelected: PropTypes.bool,
  isView: PropTypes.bool,
  isArray: PropTypes.bool,
  YPonClick: PropTypes.func
}
SingleSelect.defaultProps = {
  value: 'select',
  isSelected: false,
  isView: false,
  isArray: false,
  YPonClick () { }
}

export default SingleSelect
